var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgTarget = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.683 2.38a5.56 5.56 0 1 0 5.022 3.169.5.5 0 1 1 .903-.43 6.56 6.56 0 1 1-2.951-3.028.5.5 0 1 1-.454.89 5.535 5.535 0 0 0-2.52-.602Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.683 4.803a3.136 3.136 0 1 0 3.03 2.326.5.5 0 0 1 .967-.257 4.136 4.136 0 1 1-2.929-2.929.5.5 0 0 1-.257.966 3.142 3.142 0 0 0-.81-.106Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.683 8.758a.818.818 0 1 0 0-1.636.818.818 0 0 0 0 1.636Zm0 1a1.818 1.818 0 1 0 0-3.637 1.818 1.818 0 0 0 0 3.637Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.632.205a.5.5 0 0 1 .309.462v.925l1.236-.206a.5.5 0 0 1 .436.847l-1.516 1.515a.5.5 0 0 1-.353.146h-1.308l-4.4 4.4a.5.5 0 0 1-.706-.708l4.399-4.399V1.88a.5.5 0 0 1 .146-.353L14.087.313a.5.5 0 0 1 .545-.108Zm-.903 2.69h.808l.265-.266-.28.046a.5.5 0 0 1-.581-.493v-.308l-.212.212v.808Z",
  fill: "currentColor"
})));

export default SvgTarget;